import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Button,
} from "reactstrap"
import { connect } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import { notificationsAPI } from "../../services/api"
import moment from "moment"

const NotificationList = (props) => {
    document.title = "Toutes les Notifications | Ticket Management"

    const [notifications, setNotifications] = useState([])
    const [loading, setLoading] = useState(true)

    const breadcrumbItems = [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Notifications", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Toutes les Notifications", breadcrumbItems)
        fetchNotifications()
    }, [])

    const fetchNotifications = async () => {
        setLoading(true)
        try {
            const res = await notificationsAPI.getAll()
            setNotifications(res.data)
        } catch (error) {
            console.error("Erreur notifications", error)
        } finally {
            setLoading(false)
        }
    }

    const markAsRead = async (id) => {
        try {
            await notificationsAPI.markAsRead(id)
            fetchNotifications()
        } catch (error) {
            console.error("Erreur marquage lu", error)
        }
    }

    const markAllAsRead = async () => {
        try {
            await notificationsAPI.markAllAsRead()
            fetchNotifications()
        } catch (error) {
            console.error("Erreur tout marquer lu", error)
        }
    }

    return (
        <React.Fragment>
            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <CardTitle className="h4">Historique des Notifications</CardTitle>
                                <Button color="primary" onClick={markAllAsRead}>
                                    Tout marquer comme lu
                                </Button>
                            </div>

                            {loading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">Chargement...</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-hover mb-0">
                                        <thead>
                                            <tr>
                                                <th>Statut</th>
                                                <th>Type</th>
                                                <th>Titre</th>
                                                <th>Message</th>
                                                <th>Date</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {notifications.map((n) => (
                                                <tr key={n.id} className={!n.lu ? "bg-light" : ""}>
                                                    <td>
                                                        {!n.lu ? (
                                                            <span className="badge bg-danger">Non lue</span>
                                                        ) : (
                                                            <span className="badge bg-success">Lue</span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <div className="avatar-xs">
                                                            <span className={`avatar-title rounded-circle bg-${n.type === 'email' ? 'info' : 'success'}`}>
                                                                <i className={`mdi mdi-${n.type === 'email' ? 'email-outline' : 'whatsapp'}`}></i>
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td className="fw-bold">{n.titre}</td>
                                                    <td>{n.message}</td>
                                                    <td>{moment(n.created_at).format("DD/MM/YYYY HH:mm")}</td>
                                                    <td>
                                                        {!n.lu && (
                                                            <Button
                                                                color="soft-primary"
                                                                size="sm"
                                                                onClick={() => markAsRead(n.id)}
                                                            >
                                                                Marquer comme lue
                                                            </Button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                            {notifications.length === 0 && (
                                                <tr>
                                                    <td colSpan="6" className="text-center py-4">
                                                        Aucune notification trouvée.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(NotificationList)
